import { render } from "./popupBase2.vue?vue&type=template&id=03e4cb8a&scoped=true"
import script from "./popupBase2.vue?vue&type=script&lang=js"
export * from "./popupBase2.vue?vue&type=script&lang=js"

import "./popupBase2.vue?vue&type=style&index=0&id=03e4cb8a&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e4cb8a"]])

export default __exports__